<template>
  <UploadPhoto
    :file-type="'jpg/png'"
    :label="'Add images'"
    v-model="photo"
    :disabled="files.length >= 4"
  />
  <ion-progress-bar v-if="isLoading" type="indeterminate"></ion-progress-bar>

  <ion-row>
    <ion-col v-for="(image, idx) in files" size="3" :key="`image-incidence-${idx}`">
      <img class="img-incidence" :src="image as string"  alt="img-incidence" />
      <ion-button
        @click="removeImage(idx)"
        class="btn-remove"
        color="light"
        shape="round"
        size="small"
        fill="solid"
      >
        <ion-icon size="small" color="grey" :icon="closeOutline"></ion-icon> </ion-button
    ></ion-col>
  </ion-row>
</template>

<script setup lang="ts">
  import { IonButton, IonIcon, IonRow, IonCol, IonProgressBar } from '@ionic/vue';
  import { ref, watch } from 'vue';
  import UploadPhoto from '../shared/UploadPhoto.vue';
  import { IUploadImage } from '@/interfaces/IUploadImage';
  import { closeOutline } from 'ionicons/icons';

  defineProps({
    files: {
      type: Array,
      required: false,
      default: () => ([]),
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
  });

  const photo = ref<IUploadImage>({
    base64: '',
    title: '',
    size: 0,
  });

  const emit = defineEmits(['upload-file', 'remove-file']);

  const removeImage = (index: number) => {
    emit('remove-file', index);
  };

  const handleUploadImage = async (img64: string) => {
    emit('upload-file', img64);
  };

  watch(photo, (val) => {
    if (val.base64 !== '') {
      handleUploadImage(val.base64 as string);
    }
  });
</script>

<style lang="css" scoped>
  .img-incidence {
    border-radius: 12px;
    width: 100% !important;
    height: 100% !important;
    max-height: 64px !important;
    object-fit: cover !important;
  }

  .btn-remove {
    position: absolute;
    top: 0;
    right: 0;
  }
</style>
